import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { BaseService } from '../../shared/services/base.service';
import { ConstantsService } from '../../shared/services/constants.service';
import { DataService } from '../../shared/services/data.service';
import { PermitToWorkConstantsService } from './permittowork-constants.service';

@Injectable()
export class PermitToWorkService {
  activityUrl = "/api/activities"
  url = ConstantsService.URL.API + this.activityUrl;
  public currentPTWPageIndex: number;

  constructor(private dataService: DataService, private baseService: BaseService) { }

  getPTWRequests(model, callbackMethod) {
    return this.dataService.post(PermitToWorkConstantsService.PTWGetURL.GetPTWRequests, model).subscribe(
      response => callbackMethod(response)
    );
  }

  getPTWRequestByPermitId(model, callbackMethod) {
    return this.dataService.post(PermitToWorkConstantsService.PTWGetURL.GetPTWRequestByPermitId, model).subscribe(
      response => callbackMethod(response)
    );
  }
  savePTWRequests(model, callbackMethod) {
    return this.dataService.post(PermitToWorkConstantsService.PTWGetURL.savePTWRequest, model).subscribe(
      response => callbackMethod(response)
    );
  }
  saveGasTestRecords(model, callbackMethod) {
    return this.dataService.post(PermitToWorkConstantsService.PTWGetURL.saveGasTestRecords, model).subscribe(
      response => callbackMethod(response)
    );
  }
  saveApprovals(model, callbackMethod) {
    return this.dataService.post(PermitToWorkConstantsService.PTWGetURL.saveApprovals, model).subscribe(
      response => callbackMethod(response)
    );
  }

  saveAllTablesRecords(model, callbackMethod) {
    return this.dataService.post(PermitToWorkConstantsService.PTWGetURL.saveAllTablesRecords, model).subscribe(
      response => callbackMethod(response)
    );
  }

  getAllTablesRecords(model, callbackMethod) {
    return this.dataService.post(PermitToWorkConstantsService.PTWGetURL.getAllTablesRecords, model).subscribe(
      response => callbackMethod(response)
    );
  }

  getTRICTablesRecords(model, callbackMethod) {
    return this.dataService.post(PermitToWorkConstantsService.PTWGetURL.getTRICTablesRecords, model).subscribe(
      response => callbackMethod(response)
    );
  }
  getPTWStatus(model, callbackMethod) {
    return this.dataService.post(PermitToWorkConstantsService.PTWGetURL.getPTWStatus, model).subscribe(
      response => callbackMethod(response)
    );
  }
  getActivities() {
    const url = "api/ptw/get/getPermitActivities";
    return this.dataService.post(url, {}).pipe(map(x => x));
    //return this.http.post(url,{}).pipe(map(x => x));
  }

  getSubActivities(model) {
    //const url = `?UserId=${model.UserId}`;
    const data = { Model: { ActivityId: model } }
    const model1 = { "ActivityId": 5 }
    const url = "api/ptw/get/getSubActivitiesByActivityId";
    return this.dataService.post(url, data).pipe(map(x => x));
  }

  getCertificates(IsDelete) {
    const data = { Model: {  IsDelete: IsDelete } }
    const url = "api/ptw/get/getPTWCertificates";    
    return this.dataService.post(url, data).pipe(map(x => x));
  }

  SaveCertificates(model) {
    const url = "api/ptw/post/SaveOrUpdatePTWCertificates";
    return this.dataService.post(url, model).pipe(map(x => x));
  }

  getActivityMatrix() {
    const url = "api/ptw/get/getActivityMatrix";
    return this.dataService.post(url, {}).pipe(map(x => x));
    //return this.http.post(url,{}).pipe(map(x => x));
  }
  getAllPTWRequestIds() {
    return JSON.parse(this.baseService.getItemFromSession('PTWIds'));
  }
  public setAllPTWRequestIds(allPTWData) {
    let PTWIds = [];
    allPTWData.forEach(item => {
      PTWIds.push({ 'PermitId': item.PermitId, 'UnitId': item.UnitId });
    });
    this.baseService.setItemInSession('PTWIds', JSON.stringify(PTWIds));
  }
  // Get PTWPermits data
  exportToExcelPTWpermits(model, callbackMethod) {
    this.dataService.post(PermitToWorkConstantsService.PTWGetURL.ExportToExcelPTWPermits, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  getPermitDataForMap() {
    return this.dataService.post(PermitToWorkConstantsService.PTWGetURL.GetPermitDataForMap, {})
  }

  downloadPDF(model, callbackMethod) {
    this.dataService.postHttpResponse("api/ptw/get/downloadpdf", model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  downloadZIP(model, callbackMethod) {
    const url = "api/ptw/get/downloadzip"
    this.dataService.postHttpResponse(url, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  setcurrentPTWPageIndex(pageId) {
    this.currentPTWPageIndex = pageId;
  }
}
